export default __webpack_public_path__ + "static/media/img_baseBunnyCrochetRattle_green_p.e707ab05.jpg";